export const TrafficLights = () => (
  <>
    <span className="size-2.5 rounded-full bg-[#ff5f57]" />
    <span className="size-2.5 rounded-full bg-[#febc2e]" />
    <span className="size-2.5 rounded-full bg-line" />
  </>
);

TrafficLights.displayName = "TrafficLights";
